import { BlocksIconWrench } from 'blocks-nextjs/blocks-web-components/components/icon/icons/wrench';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWrench = createComponent({ react: React, tagName: 'cat-icon-wrench', elementClass: BlocksIconWrench });
